import { Pipe, PipeTransform } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DetectionService } from '../../services/detection.service';

@Pipe({ name: 'confidenceLabel' })
export class ConfidenceLabelPipe implements PipeTransform {
  constructor(private detectionService: DetectionService) {}

  transform(confidence: number): Observable<string> {
    return this.detectionService.getDetectionThresholds().pipe(
      map(thresholds => {
        let i = 0;
        while (thresholds.length > i && confidence > thresholds[i].threshold) {
          i += 1;
        }
        return thresholds[i - 1].name;
      })
    );
  }
}
